import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CWP_IT_MULTI_RECEIVING } from '@shared/helpers/feature-toggles';
import { wldOrLegacyDocUploadResolver } from '@shared/mfe-resolver/wld-or-legacy-doc-upload.resolver';
import * as flowGuards from '@src/app/core/guards';

import { AuthGuard } from './core/guards/auth/auth.guard';
import { ClientDataGuard } from './core/guards/client/client-data.guard';
import { GatekeeperGuard } from './core/guards/gatekeeper/gatekeeper.guard';
import { IncapacitatedGuard } from './core/guards/incapacitated/incapacitated.guard';
import { InitStateGuard } from './core/guards/init-state/init-state.guard';
import { SecureContainerComponent } from './secure/secure-container/secure-container.component';

const multiITRouteData = {
  gatekeeperToggle: CWP_IT_MULTI_RECEIVING,
  redirectLocationWhenToggleOff: 'internal-transfer/overview',
};
export const divorceRoutes: Routes = [
  {
    path: 'secure/divorce',
    canActivate: [AuthGuard, ClientDataGuard, InitStateGuard, IncapacitatedGuard],
    component: SecureContainerComponent,
    children: [
      // divorce secure pages
      {
        path: 'upload',
        canActivate: [
          flowGuards.DivorceEligibilityMultiItGuard,
          flowGuards.DivorceEligibilityGuard,
        ],
        resolve: {
          'doc-upload-mfe': wldOrLegacyDocUploadResolver,
        },
        loadChildren: () =>
          import('./secure/document-upload/document-upload.module').then(
            (m) => m.DocumentUploadModule,
          ),
      },
      {
        path: 'holdings-review',
        loadChildren: () =>
          import(
            './secure/internal-transfer-holdings-review/containers/internal-transfer-holdings-review-classic/internal-transfer-holdings-review-classic.module'
          ).then((m) => m.InternalTransferHoldingsReviewClassicModule),
      },
      {
        path: 'transfer-details',
        loadChildren: () =>
          import('./secure/internal-transfer-details/internal-transfer-details.module').then(
            (m) => m.InternalTransferDetailsModule,
          ),
      },
      {
        path: 'terms',
        loadChildren: () => import('./secure/terms/terms.module').then((m) => m.TermsModule),
      },
      {
        path: 'from-to',
        canActivate: [GatekeeperGuard],
        data: multiITRouteData,
        loadChildren: () =>
          import('./secure/internal-transfers/from-to/internal-transfer-from-to.module').then(
            (m) => m.InternalTransferFromToModule,
          ),
      },
      {
        path: 'amounts',
        canActivate: [GatekeeperGuard],
        data: multiITRouteData,
        loadChildren: () =>
          import('./secure/internal-transfers/amounts/internal-transfer-amounts.module').then(
            (m) => m.InternalTransferAmountsModule,
          ),
      },
      {
        path: 'cost-basis-election',
        canActivate: [GatekeeperGuard],
        data: multiITRouteData,
        loadChildren: () =>
          import(
            './secure/internal-transfers/cost-basis-election-multi/internal-transfer-cost-basis-election-multi.module'
          ).then((m) => m.InternalTransferCostBasisElectionMultiModule),
      },
      {
        path: 'multi-review',
        canActivate: [GatekeeperGuard],
        data: multiITRouteData,
        loadChildren: () =>
          import(
            './secure/internal-transfers/multi-review/internal-transfer-multi-review.module'
          ).then((m) => m.InternalTransferMultiReviewModule),
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forRoot(divorceRoutes)],
  exports: [RouterModule],
  providers: [GatekeeperGuard],
})
export class DivorceRoutingModule {}
